import React from 'react';
import { Link } from 'react-router-dom';
import './EnConstruccion.css';

/**
 * Página "En construcción" para rutas del dashboard que aún no existen.
 * Muestra logo Tecno3F, imagen ilustrativa y mensaje de que se está trabajando en la mejora.
 */
const EnConstruccion = () => {
  const bgImage = `${process.env.PUBLIC_URL || ''}/images/campus.png`;
  return (
    <div className="en-construccion-page" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="en-construccion-card">
        <img
          src={`${process.env.PUBLIC_URL || ''}/images/logotecno3f.png`}
          alt="Tecno3F"
          className="en-construccion-logo"
        />
        <img
          src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&q=80"
          alt="Trabajo en equipo"
          className="en-construccion-illustration"
        />
        <h1 className="en-construccion-title">En desarrollo</h1>
        <p className="en-construccion-message">
          Estamos trabajando en esta mejora para mejorar el campus.
        </p>
        <p className="en-construccion-sub">
          Este recurso estará disponible pronto. Gracias por tu paciencia.
        </p>
        <Link to="/dashboard" className="en-construccion-btn">
          Volver al Dashboard
        </Link>
      </div>
    </div>
  );
};

export default EnConstruccion;
